import { Icon } from "@iconify/react";

const navConfig = [
  {
    id: 1,
    title: "Dashboard",
    path: "/dashboard",
    icon: <Icon icon="mdi:view-dashboard-outline" width="20" height="20" />,
  },
  // {
  //   id: 2,
  //   title: "Received",
  //   path: "/received",
  //   icon: <Icon icon='mdi:email-receive-outline' width='20' height='20' />,
  // },
  // {
  //   id: 3,
  //   title: "Sent",
  //   path: "/sent",
  //   icon: <Icon icon='mingcute:send-plane-line' width='20' height='20' />,
  // },
  {
    id: 4,
    title: "Reports",
    path: "/reports",
    icon: <Icon icon="tabler:report" width="20" height="20" />,
  },
  // {
  //   id: 5,
  //   title: "Client Report",
  //   path: "/client-report",
  //   icon: <Icon icon='mdi:credit-card-edit-outline' width='20' height='20' />,
  // },
  {
    id: 6,
    title: "Credit Balance History",
    path: "/client-balance",
    icon: <Icon icon="mdi:wallet-outline" width="20" height="20" />,
  },
  {
    id: 7,
    title: "Recharge History",
    path: "/client-history",
    icon: <Icon icon="mdi:cash-multiple" width="20" height="20" />,
  },
  {
    id: 8,
    title: "Credentials",
    path: "/credentials",
    icon: <Icon icon="mdi:key-outline" width="20" height="20" />,
  },
];

const navProfile = [
  {
    id: 1,
    title: "Profile",
    path: "/profile",
    icon: <Icon icon="iconoir:profile-circle" width="20" height="20" />,
  },
];
export { navConfig, navProfile };
